import React, { useState, useEffect } from 'react';
import { calculateDayStats } from '../lib/dateUtils';
import { DayStats } from '../types';

interface DayCounterProps {
  sinceDate?: string;
}

export const DayCounter: React.FC<DayCounterProps> = ({ sinceDate = '2026-09-22' }) => {
  const [stats, setStats] = useState<DayStats>(() => calculateDayStats(sinceDate, null));
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Recalculate immediately when sinceDate changes
    setStats(calculateDayStats(sinceDate, null));

    // Tick every second to update live counts
    const interval = setInterval(() => {
      setStats(calculateDayStats(sinceDate, null));
    }, 1000);

    return () => clearInterval(interval);
  }, [sinceDate]);

  return (
    <div 
      className="flex flex-col items-center justify-center text-center select-none cursor-pointer transition-transform active:scale-98"
      onClick={() => setShowDetails(!showDetails)}
      title="Click to toggle live details"
    >
      {/* Primary Minimal Day Number */}
      <h1 className="text-7xl sm:text-8xl md:text-9xl font-black tracking-tighter text-white font-sans drop-shadow-sm">
        Day {stats.dayNumber}
      </h1>

      {/* Optional live time breakdown when clicked */}
      {showDetails && (
        <div className="mt-4 flex items-center gap-3 text-xs sm:text-sm font-mono text-zinc-400 animate-fadeIn">
          <span>{stats.totalDaysElapsed}d</span>
          <span className="text-zinc-600">•</span>
          <span>{String(stats.hours).padStart(2, '0')}h</span>
          <span className="text-zinc-600">•</span>
          <span>{String(stats.minutes).padStart(2, '0')}m</span>
          <span className="text-zinc-600">•</span>
          <span className="text-emerald-400">{String(stats.seconds).padStart(2, '0')}s</span>
        </div>
      )}
    </div>
  );
};
